import { fetchApi } from "./fetchApi";

const getDomain = ({ query, type, uid }) => {
  let domain = ["&", ["type", "=", "opportunity"]];
  if (query || type) {
    if (query) {
      domain.push("&");
    }
    if (type) {
      domain.push("&");
    }

    domain.push(["user_id", "=", uid]);

    if (query) {
      domain.push(
        "|",
        "|",
        "|",
        "|",
        ["partner_id", "ilike", query],
        ["partner_name", "ilike", query],
        ["email_from", "ilike", query],
        ["name", "ilike", query],
        ["contact_name", "ilike", query]
      );
    }
    if (type) {
      domain.push("&", ...JSON.parse(type));
    }
  } else {
    domain.push(["user_id", "=", uid]);
  }

  return domain;
};

export async function webReadGroup({
  company_id,
  context,
  selectedView,
  search = { query: "", type: "" },
  // webReadGroupDomain: domain,
}) {
  const domain = getDomain({ ...search, ...context });

  const myHeaders = new Headers();
  myHeaders.append("Accept", "application/json, text/javascript, */*; q=0.01");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Requested-With", "XMLHttpRequest");

  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [],
      model: "crm.lead",
      method: "web_read_group",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],
          params: {
            cids: company_id,
            model: "crm.lead",
            view_type: selectedView === "kanbanView" ? "kanban" : "list",
          },
          default_type: "opportunity",
          search_default_assigned_to_me: 1,
        },
        domain,

        fields: [
          "stage_id",
          "color",
          "priority",
          "expected_revenue",
          "kanban_state",
          "activity_date_deadline",
          "user_email",
          "user_id",
          "partner_id",
          "activity_summary",
          "active",
          "company_currency",
          "activity_state",
          "activity_ids",
          "name",
          "tag_ids",
          "activity_exception_decoration",
          "activity_exception_icon",
        ],
        groupby: ["stage_id"],
        orderby: "",
        lazy: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    return fetchApi({
      requestOptions,
      endpoint: `/web/dataset/call_kw/crm.lead/web_read_group`,
    });
  } catch (error) {
    console.error("An error occurred:", error);
    throw error; // Re-throw the error to propagate it to the caller
  }
}
